import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Constants } from "./constants";
const version_number = 1.0;
const headers = new HttpHeaders({});

import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import { catchError, map, tap } from "rxjs/operators";

// const httpOptions = {
//   headers: new HttpHeaders({ 'Content-Type': 'application/json' })
// };

@Injectable()
export class DataService {
  routeView: any;
  routeViewOutlet: any;
  pageName: any;
  is_prod = Constants.is_prod;
  private id: number;
  constructor(private http: HttpClient) {}
  //convert utc to localsystem date time
  convertToUTC(inputDate) {
    inputDate = inputDate + "+00:00";
    let updateInput = new Date(inputDate.replace(/\s+/g, "T")).toString();
    let removeStandardString = updateInput.split("(");
    let removeGMT = removeStandardString[0].split("G")[0];
    let addComma = removeGMT.substring(0, 7) + ", " + removeGMT.substring(7);
    let newInput = removeStandardString[0];
    return addComma;
  }
  setId(id: number) {
    this.id = id;
  }

  getId(): number {
    return this.id;
  }
  homeData(
    auth_token,
    type,
    min_date,
    max_date,
    business_list,
    business_category_list
  ) {
    // 'Content-Type': 'application/json'

    //  const headers = new HttpHeaders({});
    return this.http.post(
      Constants.apiAddress + "/home_data",
      JSON.stringify({
        auth_token,
        type,
        min_date,
        max_date,
        business_list,
        business_category_list,
        version_number,
      }),
      { headers: headers }
    );
  }
  salesData(
    auth_token,
    type,
    min_date,
    max_date,
    business_list,
    business_category_list
  ) {
    return this.http.post(
      Constants.apiAddress + "/sales_data",
      JSON.stringify({
        auth_token,
        type,
        min_date,
        max_date,
        business_list,
        business_category_list,
        version_number,
      }),
      { headers: headers }
    );
  }
  graphData(
    auth_token,
    type,
    min_date,
    max_date,
    business_list,
    business_category_list
  ) {
    // 'Content-Type': 'application/json'
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/graph_data",
      JSON.stringify({
        auth_token,
        type,
        min_date,
        max_date,
        business_list,
        business_category_list,
        version_number,
      }),
      { headers: headers }
    );
  }
  dispensarySale(auth_token, type) {
    // 'Content-Type': 'application/json'
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/dispensary_sale",
      JSON.stringify({ auth_token, type, version_number }),
      { headers: headers }
    );
  }
  getCustomersList(auth_token) {
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/customer_listing",
      JSON.stringify({ auth_token }),
      { headers: headers }
    );
  }
  searchCustomersWithFilter(auth_token, search_string, filter_type) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/customer_listing",
      JSON.stringify({
        auth_token,
        search_string,
        filter_type,
        version_number,
      }),
      { headers: headers }
    );
  }
  getCustomersListByPage(auth_token, page) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/customer_listing",
      JSON.stringify({ auth_token, page, version_number }),
      { headers: headers }
    );
  }
  showCustomerListById(auth_token, customer_id) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_customer_detail",
      JSON.stringify({ auth_token, customer_id, version_number }),
      { headers: headers }
    );
  }
  getDriverList(auth_token) {
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/driver_listing",
      JSON.stringify({ auth_token }),
      { headers: headers }
    );
  }
  getCateogryList(auth_token, dispensary_id) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_product_categories",
      JSON.stringify({ auth_token, dispensary_id, version_number }),
      { headers: headers }
    );
  }
  getCateogryList1(auth_token, category_id, is_category) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_product_categories",
      JSON.stringify({ auth_token, category_id, is_category, version_number }),
      { headers: headers }
    );
  }
  getCateogryListPage(auth_token, page) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_product_categories",
      JSON.stringify({ auth_token, page, version_number }),
      { headers: headers }
    );
  }
  searchCategory(auth_token, search_string, dispensary_id) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_product_categories",
      JSON.stringify({
        auth_token,
        search_string,
        dispensary_id,
        version_number,
      }),
      { headers: headers }
    );
  }
  addProductType(auth_token, product_type, description, category_image) {
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/add_product_type",
      JSON.stringify({
        auth_token,
        product_type,
        description,
        category_image,
        version_number,
      }),
      { headers: headers }
    );
  }
  generateUUID() {
    var d = new Date().getTime();
    var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
    return uuid;
  }
  googleAddress(input_string) {
    var sessiontoken = localStorage.getItem("sessiontoken");
    if (sessiontoken == null || sessiontoken == "") {
      sessiontoken = this.generateUUID();
      localStorage.setItem("sessiontoken", sessiontoken);
    }

    return this.http.post(
      Constants.apiAddress + "/get_google_place_suggestion",
      JSON.stringify({ input_string, sessiontoken }),
      { headers: headers }
    );
  }
  googleAddressDetail(placeId) {
    var sessiontoken = localStorage.getItem("sessiontoken");
    localStorage.setItem("sessiontoken", "");

    return this.http.post(
      Constants.apiAddress + "/get_google_place_detail",
      JSON.stringify({ placeId, sessiontoken }),
      { headers: headers }
    );
  }

  searchDriverWithFilter(auth_token, search_string, filter_type) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/driver_listing",
      JSON.stringify({
        auth_token,
        search_string,
        filter_type,
        version_number,
      }),
      { headers: headers }
    );
  }
  getDriverListByPage(auth_token, page) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/driver_listing",
      JSON.stringify({ auth_token, page, version_number }),
      { headers: headers }
    );
  }
  validateNumber(auth_token, phone_number) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/validate_number",
      JSON.stringify({ auth_token, phone_number, version_number }),
      { headers: headers }
    );
  }
  showDriverDetailWithId(auth_token, driver_id) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_driver_detail",
      JSON.stringify({ auth_token, driver_id, version_number }),
      { headers: headers }
    );
  }
  acceptDriver(auth_token, driver_id) {
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/accept_driver",
      JSON.stringify({ auth_token, driver_id, version_number }),
      { headers: headers }
    );
  }
  rejectDriver(auth_token, driver_id) {
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/reject_driver",
      JSON.stringify({ auth_token, driver_id, version_number }),
      { headers: headers }
    );
  }
  acceptCategory(auth_token, category_id) {
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/approve_category",
      JSON.stringify({ auth_token, category_id, version_number }),
      { headers: headers }
    );
  }
  rejectCategory(auth_token, category_id) {
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/reject_category",
      JSON.stringify({ auth_token, category_id, version_number }),
      { headers: headers }
    );
  }
  featuredCategory(auth_token, category_id) {
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/set_category_featured",
      JSON.stringify({ auth_token, category_id, version_number }),
      { headers: headers }
    );
  }
  getoutletsList(auth_token) {
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_outlets",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  getoutletsListOfBusiness(auth_token, dispensary_id) {
    // 'Content-Type': 'application/json'
    return this.http.post(
      Constants.apiAddress + "/get_outlets",
      JSON.stringify({ auth_token, dispensary_id, version_number }),
      { headers: headers }
    );
  }
  searchOutletsListFilter(
    auth_token,
    search_string,
    filter_type,
    status,
    business_category_id
  ) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_outlets",
      JSON.stringify({
        auth_token,
        search_string,
        filter_type,
        status,
        business_category_id,
        version_number,
      }),
      { headers: headers }
    );
  }

  searchOutletsListFilters(
    auth_token,
    search_string,
    filter_type,
    status,
    business_category_id,
    page,
    city_id
  ) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/dispensary_list",
      JSON.stringify({
        auth_token,
        search_string,
        filter_type,
        status,
        business_category_id,
        page,
        city_id,
        version_number,
      }),
      { headers: headers }
    );
  }

  getOutletListByPage(
    auth_token,
    search_string,
    filter_type,
    status,
    category_name,
    page
  ) {
    return this.http.post(
      Constants.apiAddress + "/get_outlets",
      JSON.stringify({
        auth_token,
        search_string,
        filter_type,
        status,
        category_name,
        page,
        version_number,
      }),
      { headers: headers }
    );
  }
  getSeoBusiness(
    auth_token,
    dispensary_id,
    seo_title,
    seo_description,
    seo_keyword
  ) {
    // 'Content-Type': 'application/json'
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/add_edit_business_seo",
      JSON.stringify({
        auth_token,
        dispensary_id,
        version_number,
        seo_title,
        seo_description,
        seo_keyword,
      }),
      { headers: headers }
    );
  }

  getSeoBusinessDetail(auth_token, dispensary_id) {
    // 'Content-Type': 'application/json'
    return this.http.post(
      Constants.apiAddress + "/get_business_seo",
      JSON.stringify({ auth_token, version_number, dispensary_id }),
      { headers: headers }
    );
  }

  getBusinessPlatformDetails(auth_token, dispensary_id, app_type) {
    // 'Content-Type': 'application/json'
    return this.http.post(
      Constants.apiAddress + "/get_business_platform_charges",
      JSON.stringify({ auth_token, version_number, dispensary_id, app_type }),
      { headers: headers }
    );
  }

  saveBusinessPlatformDetails(
    auth_token,
    dispensary_id,
    flat_fee_check,
    minimum_flat_amount,
    flat_fee,
    percentage_fee_check,
    minimum_percentage_amount,
    default_percentage_fee,
    dinein_flat_fee,
    dinein_default_percentage_fee,
    dinein_minimum_flat_amount,
    dinein_minimum_percentage_amount,
    pickup_flat_fee,
    pickup_default_percentage_fee,
    pickup_minimum_flat_amount,
    pickup_minimum_percentage_amount,
    dinein_flat_fee_check,
    dinein_percentage_fee_check,
    pickup_flat_fee_check,
    pickup_percentage_fee_check,
    app_type
  ) {
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/add_edit_business_platform_charges",
      JSON.stringify({
        auth_token,
        version_number,
        dispensary_id,
        flat_fee_check,
        minimum_flat_amount,
        flat_fee,
        percentage_fee_check,
        minimum_percentage_amount,
        default_percentage_fee,
        dinein_flat_fee,
        dinein_default_percentage_fee,
        dinein_minimum_flat_amount,
        dinein_minimum_percentage_amount,
        pickup_flat_fee,
        pickup_default_percentage_fee,
        pickup_minimum_flat_amount,
        pickup_minimum_percentage_amount,
        dinein_flat_fee_check,
        dinein_percentage_fee_check,
        pickup_flat_fee_check,
        pickup_percentage_fee_check,
        app_type,
      }),
      { headers: headers }
    );
  }

  saveBusinessCategoryPlatformDetails(
    auth_token,
    dispensary_id,
    category_id,
    flat_category_fee,
    percentage_category_fee,
    flat_category_fee_check,
    percentage_category_fee_check,
    default_category_fee_check
  ) {
    // 'Content-Type': 'application/json'
    return this.http.post(
      Constants.apiAddress + "/add_edit_category_platform_charges",
      JSON.stringify({
        auth_token,
        version_number,
        dispensary_id,
        category_id,
        flat_category_fee,
        percentage_category_fee,
        flat_category_fee_check,
        percentage_category_fee_check,
        default_category_fee_check,
      }),
      { headers: headers }
    );
  }

  getBusinessPlatformDetailsCategory(auth_token, dispensary_id) {
    // 'Content-Type': 'application/json'
    return this.http.post(
      Constants.apiAddress + "/get_category_platform_charges",
      JSON.stringify({ auth_token, version_number, dispensary_id }),
      { headers: headers }
    );
  }

  getSeoHomeDetail(auth_token) {
    // 'Content-Type': 'application/json'
    return this.http.post(
      Constants.apiAddress + "/get_home_seo",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  getSeoHomeEdit(auth_token, seo_title, seo_description, seo_keyword) {
    // 'Content-Type': 'application/json'
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/add_edit_home_seo",
      JSON.stringify({
        auth_token,
        version_number,
        seo_title,
        seo_description,
        seo_keyword,
      }),
      { headers: headers }
    );
  }

  // getBusinessList(auth_token) {
  //   // 'Content-Type': 'application/json'
  //   return this.http.post(Constants.apiAddress + '/dispensary_listing', JSON.stringify({ auth_token, version_number}),
  //     { headers: headers });
  // }

  getOutletsById(
    auth_token,
    dispensary_id,
    seo_title,
    seo_description,
    seo_keyword
  ) {
    // 'Content-Type': 'application/json'
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/get_dispensary_detail",
      JSON.stringify({
        auth_token,
        dispensary_id,
        version_number,
        seo_title,
        seo_description,
        seo_keyword,
      }),
      { headers: headers }
    );
  }
  getOutletsByIds(auth_token, dispensary_id) {
    return this.http.post(
      Constants.apiAddress + "/get_outlets",
      JSON.stringify({ auth_token, dispensary_id, version_number }),
      { headers: headers }
    );
  }

  getDispensaryCategories(auth_token, dispensary_id) {
    // 'Content-Type': 'application/json'
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/get_dipensary_categories",
      JSON.stringify({ auth_token, dispensary_id, version_number }),
      { headers: headers }
    );
  }
  removeAdmin(auth_token, manager_id, is_username) {
    // 'Content-Type': 'application/json'
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/remove_manager",
      JSON.stringify({ auth_token, manager_id, is_username, version_number }),
      { headers: headers }
    );
  }
  sendEmail(auth_token, id) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/send_email",
      JSON.stringify({ auth_token, id, version_number }),
      { headers: headers }
    );
  }
  resendEmailToAdmin(auth_token, dispensary_id, email) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/reinvite_dispensary_admin",
      JSON.stringify({ auth_token, dispensary_id, email, version_number }),
      { headers: headers }
    );
  }
  forceReset(auth_token, alias, username) {
    return this.http.post(
      Constants.apiAddress + "/force_reset_password",
      JSON.stringify({ auth_token, alias, username, version_number }),
      { headers: headers }
    );
  }
  availableDispensaryName(auth_token, dispensary_name) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/check_dispensary_name",
      JSON.stringify({ auth_token, dispensary_name, version_number }),
      { headers: headers }
    );
  }
  addCustomer(
    auth_token,
    first_name,
    last_name,
    phone,
    email,
    is_tax_exempt,
    accept_marketing,
    address_line1,
    street,
    address_line2,
    city,
    state,
    zip,
    area,
    apart_no,
    note,
    dob,
    latitude,
    longitude,
    house_building_no,
    gender,
    dispensary_id
  ) {
    // 'Content-Type': 'application/json'
    return this.http.post(
      Constants.apiAddress + "/add_customer",
      JSON.stringify({
        auth_token,
        first_name,
        last_name,
        phone,
        email,
        is_tax_exempt,
        accept_marketing,
        address_line1,
        street,
        address_line2,
        city,
        state,
        zip,
        area,
        apart_no,
        note,
        dob,
        latitude,
        longitude,
        house_building_no,
        gender,
        version_number,
        dispensary_id,
      }),
      { headers: headers }
    );
  }
  editCustomer(
    auth_token,
    first_name,
    last_name,
    phone,
    email,
    is_tax_exempt,
    accept_marketing,
    note,
    dob,
    gender,
    client_id
  ) {
    // 'Content-Type': 'application/json'

    // const version_number = 1.0;
    return this.http.post(
      Constants.apiAddress + "/edit_customer",
      JSON.stringify({
        auth_token,
        first_name,
        last_name,
        phone,
        email,
        is_tax_exempt,
        accept_marketing,
        note,
        dob,
        gender,
        client_id,
        version_number,
      }),
      { headers: headers }
    );
  }

  addDriver(
    auth_token,
    first_name,
    last_name,
    phone,
    email,
    dob,
    address_line1,
    street,
    address_line2,
    city,
    zip,
    state,
    area,
    note,
    driving_license_front,
    driving_license_back,
    registration_book,
    latitude,
    longitude
  ) {
    // 'Content-Type': 'application/json'

    // const version_number = 1.0;
    return this.http.post(
      Constants.apiAddress + "/add_driver",
      JSON.stringify({
        auth_token,
        first_name,
        last_name,
        phone,
        email,
        dob,
        address_line1,
        street,
        address_line2,
        city,
        zip,
        state,
        area,
        note,
        driving_license_front,
        driving_license_back,
        registration_book,
        latitude,
        longitude,
        version_number,
      }),
      { headers: headers }
    );
  }
  editDriver(
    auth_token,
    first_name,
    last_name,
    phone,
    email,
    edit_order_access,
    edit_quantity_access,
    create_order_access,
    dob,
    address_line1,
    street,
    address_line2,
    city,
    zip,
    state,
    area,
    note,
    driving_license_front,
    driving_license_back,
    registration_book,
    driver_id,
    latitude,
    longitude
  ) {
    // 'Content-Type': 'application/json'

    const version_number = 1.0;
    return this.http.post(
      Constants.apiAddress + "/edit_driver",
      JSON.stringify({
        auth_token,
        first_name,
        last_name,
        phone,
        email,
        edit_order_access,
        edit_quantity_access,
        create_order_access,
        dob,
        address_line1,
        street,
        address_line2,
        city,
        zip,
        state,
        area,
        note,
        driving_license_front,
        driving_license_back,
        registration_book,
        driver_id,
        latitude,
        longitude,
        // version_number
      }),
      { headers: headers }
    );
  }
  addDispansary(
    auth_token,
    name,
    business_category_id,
    about,
    number,
    email,
    image,
    address,
    street,
    city,
    zip,
    state,
    area,
    apart_no,
    open_time,
    close_time,
    manager_name,
    manager_email,
    square_image,
    square_logo_image,
    latitude,
    longitude,
    time_zone
  ) {
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/add_dispensary",
      JSON.stringify({
        auth_token,
        name,
        business_category_id,
        about,
        number,
        email,
        image,
        address,
        street,
        city,
        zip,
        state,
        area,
        apart_no,
        open_time,
        close_time,
        manager_name,
        manager_email,
        square_image,
        square_logo_image,
        latitude,
        longitude,
        time_zone,
      }),
      { headers: headers }
    );
  }
  editDispansary(
    auth_token,
    name,
    business_category_id,
    //  business_second_category_id,
    about,
    number,
    email,
    image,
    address,
    street,
    city,
    zip,
    state,
    area,
    apart_no,
    manager_name,
    manager_email,
    square_image,
    square_logo_image,
    cover_image,
    business_logo_image,
    latitude,
    longitude,
    dispensary_id,
    time_zone,
    outlet_type,
    time_list,
    name_time_zone,
    seo_title,
    seo_description,
    seo_keyword,
    business_prod_relation
  ) {
    // 'Content-Type': 'application/json'

    // const version_number = 1.0;
    return this.http.post(
      Constants.apiAddress + "/edit_dispensary",
      JSON.stringify({
        auth_token,
        name,
        business_category_id,
        // business_second_category_id,
        about,
        number,
        email,
        image,
        address,
        street,
        city,
        zip,
        state,
        area,
        apart_no,
        manager_name,
        manager_email,
        square_image,
        square_logo_image,
        cover_image,
        business_logo_image,
        latitude,
        longitude,
        dispensary_id,
        time_zone,
        outlet_type,
        time_list,
        name_time_zone,
        version_number,
        seo_title,
        seo_description,
        seo_keyword,
        business_prod_relation,
      }),
      { headers: headers }
    );
  }
  getCustomersReport(auth_token) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_customer_report",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  getCustomersReportByPage(auth_token, page) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_customer_report",
      JSON.stringify({ auth_token, page, version_number }),
      { headers: headers }
    );
  }
  getDriverReport(auth_token) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_driver_report",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  getDriversReportByPage(auth_token, page) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_driver_report",
      JSON.stringify({ auth_token, page, version_number }),
      { headers: headers }
    );
  }
  getDispensaryReport(auth_token) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_dispensary_report",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  getDispensaryReportByPage(auth_token, page) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_dispensary_report",
      JSON.stringify({ auth_token, page, version_number }),
      { headers: headers }
    );
  }
  supportList(auth_token) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_contact_support_messages",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  supportListSearchFilter(auth_token, search_string, filter_type) {
    return this.http.post(
      Constants.apiAddress + "/get_contact_support_messages",
      JSON.stringify({
        auth_token,
        search_string,
        filter_type,
        version_number,
      }),
      { headers: headers }
    );
  }
  supportListSearchFilterByPage(auth_token, search_string, filter_type, page) {
    return this.http.post(
      Constants.apiAddress + "/get_contact_support_messages",
      JSON.stringify({
        auth_token,
        search_string,
        filter_type,
        page,
        version_number,
      }),
      { headers: headers }
    );
  }
  readMessage(auth_token, message_id) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/read_message",
      JSON.stringify({ auth_token, message_id, version_number }),
      { headers: headers }
    );
  }
  getStoreList(auth_token) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_city_list",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  uploadCity(
    auth_token,
    short_name,
    city,
    country,
    lower_range,
    file,
    is_nation_wide,
    html_description,
    seo_title,
    seo_description,
    seo_keyword
  ) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/upload_city",
      JSON.stringify({
        auth_token,
        short_name,
        city,
        country,
        lower_range,
        file,
        is_nation_wide,
        html_description,
        seo_title,
        seo_description,
        seo_keyword,
        version_number,
      }),
      { headers: headers }
    );
  }
  editCityData(
    auth_token,
    city_id,
    short_name,
    city,
    country,
    lower_range,
    file,
    html_description,
    seo_title,
    seo_description,
    seo_keyword
  ) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/edit_city",
      JSON.stringify({
        auth_token,
        city_id,
        short_name,
        city,
        country,
        lower_range,
        file,
        html_description,
        seo_title,
        seo_description,
        seo_keyword,
        version_number,
      }),
      { headers: headers }
    );
  }
  deleteCity(auth_token, id) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/delete_city",
      JSON.stringify({ auth_token, id, version_number }),
      { headers: headers }
    );
  }
  availableCityList(auth_token, city, zip) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/available_city",
      JSON.stringify({ auth_token, city, zip, version_number }),
      { headers: headers }
    );
  }
  cityDetail(auth_token, city_id) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_city_detail",
      JSON.stringify({ auth_token, city_id, version_number }),
      { headers: headers }
    );
  }
  driverReportDetail(auth_token, driver_id, type, start_date, end_date) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_driver_earning",
      JSON.stringify({
        auth_token,
        driver_id,
        type,
        start_date,
        end_date,
        version_number,
      }),
      { headers: headers }
    );
  }
  userReportDetail(auth_token, client_id, type, start_date, end_date) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_customer_spending",
      JSON.stringify({
        auth_token,
        client_id,
        type,
        start_date,
        end_date,
        version_number,
      }),
      { headers: headers }
    );
  }
  removeProductType(auth_token, category_id) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/archive_category",
      JSON.stringify({ auth_token, category_id, version_number }),
      { headers: headers }
    );
  }
  getProductsList(auth_token, dispensary_id, outlet_id) {
    // 'Content-Type': 'application/json'
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/get_dispensary_product",
      JSON.stringify({ auth_token, dispensary_id, outlet_id, version_number }),
      { headers: headers }
    );
  }
  // searchProductWithFilter(auth_token, search_string, filter_type, dispensary_id) {
  //   // 'Content-Type': 'application/json'
  //   // const version_number = 1.0;
  //
  //   return this.http.post(Constants.apiAddress + '/get_dispensary_product', JSON.stringify({ auth_token, search_string, filter_type, dispensary_id, version_number }),
  //     { headers: headers });
  // }
  getProductsListByPage(auth_token, page, dispensary_id) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/get_dispensary_product",
      JSON.stringify({ auth_token, page, dispensary_id, version_number }),
      { headers: headers }
    );
  }
  removeProduct(auth_token, product_id, dispensary_id) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/archive_product",
      JSON.stringify({ auth_token, product_id, dispensary_id, version_number }),
      { headers: headers }
    );
  }
  // addDispensaryStock(auth_token, variant_id, dispensary_id, quantity) {
  //   // const version_number = 1.0;
  //   // 'Content-Type': 'application/json'
  //   return this.http.post(Constants.apiAddress + '/add_inventory', JSON.stringify({ auth_token, variant_id, dispensary_id, quantity, version_number }),
  //     { headers: headers });
  // }
  changeSettingsForProduct(
    auth_token,
    dispensary_id,
    is_mobile,
    is_web,
    is_nation_wide,
    is_local,
    is_cart_on_mobile,
    is_cart_on_web,
    payment_through_cash,
    payment_through_card,
    is_delivery_available,
    is_dine_in_available,
    is_pickup_available,
    delivery_payment_options,
    pickup_payment_options,
    dine_in_payment_options,
    bank_fee_percentage_customer,
    bank_fee_percentage_business
  ) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'
    return this.http.post(
      Constants.apiAddress + "/change_product_setting",
      JSON.stringify({
        auth_token,
        dispensary_id,
        is_mobile,
        is_web,
        is_nation_wide,
        is_local,
        is_cart_on_mobile,
        is_cart_on_web,
        payment_through_cash,
        payment_through_card,
        is_delivery_available,
        is_dine_in_available,
        is_pickup_available,
        delivery_payment_options,
        pickup_payment_options,
        dine_in_payment_options,
        version_number,
        bank_fee_percentage_business,
        bank_fee_percentage_customer,
      }),
      { headers: headers }
    );
  }
  addVendor(auth_token, vendor_name, description) {
    return this.http.post(
      Constants.apiAddress + "/add_vendor",
      JSON.stringify({ auth_token, vendor_name, description, version_number }),
      { headers: headers }
    );
  }
  getVendorList(auth_token) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'
    return this.http.post(
      Constants.apiAddress + "/get_vendors",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  getVendorListPage(auth_token, page) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'
    return this.http.post(
      Constants.apiAddress + "/get_vendors",
      JSON.stringify({ auth_token, page, version_number }),
      { headers: headers }
    );
  }
  searchVendor(auth_token, search_string) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'
    return this.http.post(
      Constants.apiAddress + "/get_vendors",
      JSON.stringify({ auth_token, search_string, version_number }),
      { headers: headers }
    );
  }
  acceptVendor(auth_token, vendor_id) {
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/approve_vendor",
      JSON.stringify({ auth_token, vendor_id, version_number }),
      { headers: headers }
    );
  }
  rejectVendor(auth_token, vendor_id) {
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/reject_vendor",
      JSON.stringify({ auth_token, vendor_id, version_number }),
      { headers: headers }
    );
  }
  editVendor(auth_token, vendor_name, description, vendor_id) {
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/edit_vendor",
      JSON.stringify({
        auth_token,
        vendor_name,
        description,
        vendor_id,
        version_number,
      }),
      { headers: headers }
    );
  }
  removeVendor(auth_token, vendor_id) {
    return this.http.post(
      Constants.apiAddress + "/archive_vendor",
      JSON.stringify({ auth_token, vendor_id, version_number }),
      { headers: headers }
    );
  }
  addAdmin(auth_token, dispensary_id, admin_name, email, password) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'

    return this.http.post(
      Constants.apiAddress + "/create_dispensary_admin",
      JSON.stringify({
        auth_token,
        dispensary_id,
        admin_name,
        email,
        password,
        version_number,
      }),
      { headers: headers }
    );
  }
  rejectDispensary(auth_token, dispensary_id) {
    return this.http.post(
      Constants.apiAddress + "/reject_dispensary",
      JSON.stringify({ auth_token, dispensary_id, version_number }),
      { headers: headers }
    );
  }
  acceptDispensary(
    auth_token,
    email,
    manager_name,
    dispensary_id,
    dispensary_name
  ) {
    return this.http.post(
      Constants.apiAddress + "/approve_dispensary",
      JSON.stringify({
        auth_token,
        email,
        manager_name,
        dispensary_id,
        dispensary_name,
        version_number,
      }),
      { headers: headers }
    );
  }
  addBusinessCategory(
    auth_token,
    name,
    splash_name,
    image,
    category_tile_image,
    background_hexadecimal,
    border_hexadecimal
  ) {
    return this.http.post(
      Constants.apiAddress + "/add_business_category",
      JSON.stringify({
        auth_token,
        name,
        splash_name,
        image,
        category_tile_image,
        background_hexadecimal,
        border_hexadecimal,
        version_number,
      }),
      { headers: headers }
    );
  }
  editBusinessCategory(
    auth_token,
    business_category_id,
    name,
    splash_name,
    image,
    category_tile_image,
    background_hexadecimal,
    border_hexadecimal
  ) {
    return this.http.post(
      Constants.apiAddress + "/edit_business_category",
      JSON.stringify({
        auth_token,
        business_category_id,
        name,
        splash_name,
        image,
        category_tile_image,
        background_hexadecimal,
        border_hexadecimal,
        version_number,
      }),
      { headers: headers }
    );
  }
  getBusinessCategory(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/get_business_category",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  sortBusinessCategory(auth_token, data_list, is_category) {
    return this.http.post(
      Constants.apiAddress + "/sort_data_list",
      JSON.stringify({ auth_token, data_list, is_category, version_number }),
      { headers: headers }
    );
  }
  sortBusinessSorting(auth_token, data_list, is_business_sorting) {
    return this.http.post(
      Constants.apiAddress + "/sort_data_list",
      JSON.stringify({
        auth_token,
        data_list,
        is_business_sorting,
        version_number,
      }),
      { headers: headers }
    );
  }
  businessSettings(
    auth_token,
    business_category_id,
    is_mobile,
    is_web,
    is_featured,
    is_featured_on_mobile
  ) {
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/business_category_setting",
      JSON.stringify({
        auth_token,
        business_category_id,
        is_mobile,
        is_web,
        is_featured,
        is_featured_on_mobile,
        version_number,
      }),
      { headers: headers }
    );
  }
  driverLocationFunSeeting(auth_token, business_category_id, is_track_order) {
    // const version_number = 1.0;
    return this.http.post(
      Constants.apiAddress + "/business_category_setting",
      JSON.stringify({
        auth_token,
        business_category_id,
        is_track_order,
        version_number,
      }),
      { headers: headers }
    );
  }
  businessCitySettings(auth_token, city_id, business_category_id, is_show) {
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/business_category_setting_for_city",
      JSON.stringify({
        auth_token,
        city_id,
        business_category_id,
        is_show,
        version_number,
      }),
      { headers: headers }
    );
  }
  getPrescriptionSettings(auth_token) {
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/get_settings",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  updatePrescriptionSettings(auth_token, id, need_prescription, verify_id) {
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/update_settings",
      JSON.stringify({
        auth_token,
        id,
        need_prescription,
        verify_id,
        version_number,
      }),
      { headers: headers }
    );
  }
  // googleAddress(input) {
  //   // const PROXY_URL = 'https://cors-anywhere.herokuapp.com/';
  //   return this.http.get('https://maps.googleapis.com/maps/api/place/autocomplete/json?key=AIzaSyB2WBHIFu3ngRBE7f6kISHWvr12IBka5ls&input=' + input,
  //     { headers: headers });
  // }
  // googleAddressDetail(placeId) {
  //   return this.http.get('https://maps.googleapis.com/maps/api/place/details/json?placeid=' + placeId + '&key=AIzaSyB2WBHIFu3ngRBE7f6kISHWvr12IBka5ls',
  //     { headers: headers });
  // }
  // googleAddress(input_string) {
  //   return this.http.post(Constants.apiAddress + '/get_google_place_suggestion', JSON.stringify({ input_string}),
  //     { headers: headers });
  // }
  // googleAddressDetail(placeId) {
  //   return this.http.post(Constants.apiAddress + '/get_google_place_detail', JSON.stringify({ placeId}),
  //     { headers: headers });
  // }
  getPlatformCharges(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/get_platform_charges",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  updatePlatformCharges(
    auth_token,
    id = 1,
    platform_fee,
    bank_fee_percentage = 0
  ) {
    return this.http.post(
      Constants.apiAddress + "/update_platform_charges",
      JSON.stringify({
        auth_token,
        id,
        platform_fee,
        version_number,
        bank_fee_percentage,
      }),
      { headers: headers }
    );
  }
  getInvoicesList(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/get_invoice",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  getInvoicesListbyPage(auth_token, page) {
    return this.http.post(
      Constants.apiAddress + "/get_invoice",
      JSON.stringify({ auth_token, page, version_number }),
      { headers: headers }
    );
  }
  searchInvoicesList(auth_token, search_string) {
    return this.http.post(
      Constants.apiAddress + "/get_invoice",
      JSON.stringify({ auth_token, search_string, version_number }),
      { headers: headers }
    );
  }
  getInvoiceDetail(auth_token, id) {
    return this.http.post(
      Constants.apiAddress + "/get_invoice_detail",
      JSON.stringify({ auth_token, id, version_number }),
      { headers: headers }
    );
  }
  removeSubCategory(auth_token, sub_category_id) {
    return this.http.post(
      Constants.apiAddress + "/archive_sub_category",
      JSON.stringify({ auth_token, sub_category_id, version_number }),
      { headers: headers }
    );
  }
  editProductType(
    auth_token,
    category_name,
    description,
    category_id,
    is_category,
    category_image
  ) {
    return this.http.post(
      Constants.apiAddress + "/edit_category",
      JSON.stringify({
        auth_token,
        category_name,
        description,
        category_id,
        category_image,
        is_category,
        version_number,
      }),
      { headers: headers }
    );
  }
  addPayment(auth_token, payment_mode, amount, id) {
    return this.http.post(
      Constants.apiAddress + "/add_payment",
      JSON.stringify({ auth_token, payment_mode, amount, id, version_number }),
      { headers: headers }
    );
  }
  getAccountStatement(auth_token, business_id) {
    return this.http.post(
      Constants.apiAddress + "/get_account_statement",
      JSON.stringify({ auth_token, business_id, version_number }),
      { headers: headers }
    );
  }
  addStory(auth_token, title, short_desc, admin_name, html) {
    return this.http.post(
      Constants.apiAddress + "/add_article",
      JSON.stringify({
        auth_token,
        title,
        short_desc,
        admin_name,
        html,
        version_number,
      }),
      { headers: headers }
    );
  }
  editStory(
    auth_token,
    article_id,
    title,
    short_desc,
    image_list,
    admin_name,
    html
  ) {
    return this.http.post(
      Constants.apiAddress + "/edit_article",
      JSON.stringify({
        auth_token,
        article_id,
        title,
        short_desc,
        image_list,
        admin_name,
        html,
        version_number,
      }),
      { headers: headers }
    );
  }
  addStoryImage(auth_token, article_id, image) {
    return this.http.post(
      Constants.apiAddress + "/upload_article_image",
      JSON.stringify({ auth_token, article_id, image, version_number }),
      { headers: headers }
    );
  }
  getStorylisting(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/get_article",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  getStorylistingByPage(auth_token, page) {
    return this.http.post(
      Constants.apiAddress + "/get_article",
      JSON.stringify({ auth_token, page, version_number }),
      { headers: headers }
    );
  }
  storyDetail(auth_token, article_id) {
    return this.http.post(
      Constants.apiAddress + "/get_article_detail",
      JSON.stringify({ auth_token, article_id, version_number }),
      { headers: headers }
    );
  }
  deleteStory(auth_token, article_id) {
    return this.http.post(
      Constants.apiAddress + "/delete_article",
      JSON.stringify({ auth_token, article_id, version_number }),
      { headers: headers }
    );
  }
  getBusinessActivity(auth_token, type, status, search_string) {
    // , type, status, business_id
    return this.http.post(
      Constants.apiAddress + "/get_businesses_activity",
      JSON.stringify({
        auth_token,
        type,
        status,
        search_string,
        version_number,
      }),
      // , type, status, business_id
      { headers: headers }
    );
  }
  getActivityByPage(
    auth_token,
    type,
    status,
    start_date,
    end_date,
    business_id,
    payment_method,
    search_string,
    page
  ) {
    return this.http.post(
      Constants.apiAddress + "/get_businesses_activity",
      JSON.stringify({
        auth_token,
        type,
        status,
        start_date,
        end_date,
        business_id,
        payment_method,
        search_string,
        page,
        version_number,
      }),
      { headers: headers }
    );
  }
  getWithDrawRequests(auth_token, status, type, search_string) {
    return this.http.post(
      Constants.apiAddress + "/get_with_draw_requests",
      JSON.stringify({
        auth_token,
        status,
        type,
        search_string,
        version_number,
      }),
      { headers: headers }
    );
  }
  getWithDrawRequestsByPage(auth_token, status, type, search_string, page) {
    return this.http.post(
      Constants.apiAddress + "/get_with_draw_requests",
      JSON.stringify({
        auth_token,
        status,
        type,
        search_string,
        page,
        version_number,
      }),
      { headers: headers }
    );
  }
  processWithDrawRequest(auth_token, id) {
    return this.http.post(
      Constants.apiAddress + "/change_status_of_with_draw_request",
      JSON.stringify({ auth_token, id, version_number }),
      { headers: headers }
    );
  }
  getTransactionDetails(auth_token, id) {
    return this.http.post(
      Constants.apiAddress + "/get_transaction_details",
      JSON.stringify({ auth_token, id, version_number }),
      { headers: headers }
    );
  }
  getTransactionDetailsOnWithdraw(auth_token, id) {
    return this.http.post(
      Constants.apiAddress + "/transaction_details_of_with_draw_requests",
      JSON.stringify({ auth_token, id, version_number }),
      { headers: headers }
    );
  }
  getOrderhDetail(auth_token, order_id) {
    return this.http.post(
      Constants.apiAddress + "/get_order_detail_order_module",
      JSON.stringify({ auth_token, order_id, version_number }),
      { headers: headers }
    );
  }
  createBatch(auth_token, with_draw_list) {
    return this.http.post(
      Constants.apiAddress + "/create_batch_of_with_draw_requests",
      JSON.stringify({ auth_token, with_draw_list, version_number }),
      { headers: headers }
    );
  }
  createBatchOrders(auth_token, order_list) {
    return this.http.post(
      Constants.apiAddress + "/create_batch",
      JSON.stringify({ auth_token, order_list, version_number }),
      { headers: headers }
    );
  }
  getBatchesOfWithdrawRequests(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/get_batch_of_with_draw_requests",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  getBatchesOfWithdrawRequestsByPage(auth_token, page) {
    return this.http.post(
      Constants.apiAddress + "/get_batch_of_with_draw_requests",
      JSON.stringify({ auth_token, page, version_number }),
      { headers: headers }
    );
  }
  editWithdrawRequestBatch(auth_token, batch_id, with_draw_requests_list) {
    return this.http.post(
      Constants.apiAddress + "/edit_with_draw_request_batch",
      JSON.stringify({
        auth_token,
        batch_id,
        with_draw_requests_list,
        version_number,
      }),
      { headers: headers }
    );
  }
  processBatchOfWithDrawRequests(auth_token, batch_id) {
    return this.http.post(
      Constants.apiAddress + "/process_batch_of_with_draw_requests",
      JSON.stringify({ auth_token, batch_id, version_number }),
      { headers: headers }
    );
  }
  getLogslisting(auth_token, type, limit, status, dispensary_id) {
    return this.http.post(
      Constants.apiAddress + "/get_logs",
      JSON.stringify({
        auth_token,
        type,
        limit,
        status,
        dispensary_id,
        version_number,
      }),
      { headers: headers }
    );
  }
  getLogslistingByPage(auth_token, type, page, limit, status, dispensary_id) {
    return this.http.post(
      Constants.apiAddress + "/get_logs",
      JSON.stringify({
        auth_token,
        type,
        page,
        limit,
        status,
        dispensary_id,
        version_number,
      }),
      { headers: headers }
    );
  }
  getSmsSetting(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/get_message_settings",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  editSmsSetting(
    auth_token,
    token_key_id,
    secret_key_sns,
    number_region,
    name
  ) {
    return this.http.post(
      Constants.apiAddress + "/add_message_settings",
      JSON.stringify({
        auth_token,
        token_key_id,
        secret_key_sns,
        number_region,
        name,
        version_number,
      }),
      { headers: headers }
    );
  }
  getSmsSettingValue(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/get_primary_message_settings",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  updateSmsSettingValue(auth_token, id) {
    return this.http.post(
      Constants.apiAddress + "/make_primary_message_settings",
      JSON.stringify({ auth_token, id, version_number }),
      { headers: headers }
    );
  }
  getInventory(auth_token, dispensary_id) {
    // const version_number = 1.0;
    // 'Content-Type': 'application/json'
    return this.http.post(
      Constants.apiAddress + "/get_business_outlets",
      JSON.stringify({ auth_token, dispensary_id, version_number }),
      { headers: headers }
    );
  }
  addDispensaryStock(
    auth_token,
    variant_cost,
    outlet_id,
    dispensary_id,
    quantity,
    key,
    variant_id
  ) {
    return this.http.post(
      Constants.apiAddress + "/add_inventory",
      JSON.stringify({
        auth_token,
        variant_cost,
        outlet_id,
        dispensary_id,
        quantity,
        key,
        variant_id,
        version_number,
      }),
      { headers: headers }
    );
  }
  deleteDispensaryStock(
    auth_token,
    outlet_id,
    quantity,
    dispensary_id,
    comment,
    reason_type,
    key,
    variant_id
  ) {
    return this.http.post(
      Constants.apiAddress + "/add_inventory",
      JSON.stringify({
        auth_token,
        outlet_id,
        quantity,
        dispensary_id,
        comment,
        reason_type,
        key,
        variant_id,
        version_number,
      }),
      { headers: headers }
    );
  }
  transDispensaryStock(
    auth_token,
    variant_id,
    from_outlet,
    outlet_id,
    key,
    quantity,
    dispensary_id
  ) {
    return this.http.post(
      Constants.apiAddress + "/add_inventory",
      JSON.stringify({
        auth_token,
        variant_id,
        from_outlet,
        outlet_id,
        key,
        quantity,
        dispensary_id,
        version_number,
      }),
      { headers: headers }
    );
  }
  searchProductWithFilter(
    auth_token,
    search_string,
    filter_type,
    dispensary_id,
    outlet_id
  ) {
    // 'Content-Type': 'application/json'
    // const version_number = 1.0;

    return this.http.post(
      Constants.apiAddress + "/get_dispensary_product",
      JSON.stringify({
        auth_token,
        search_string,
        filter_type,
        dispensary_id,
        outlet_id,
        version_number,
      }),
      { headers: headers }
    );
  }
  addCustomerAddress(
    auth_token,
    place_label,
    address_line1,
    city,
    state,
    zip,
    country,
    apart_no,
    client_id,
    latitude,
    longitude
  ) {
    return this.http.post(
      Constants.apiAddress + "/add_customer_address",
      JSON.stringify({
        auth_token,
        place_label,
        address_line1,
        city,
        state,
        zip,
        country,
        apart_no,
        client_id,
        latitude,
        longitude,
        version_number,
      }),
      { headers: headers }
    );
  }
  editCustomerAddress(
    auth_token,
    place_label,
    address_line1,
    city,
    state,
    zip,
    country,
    apart_no,
    client_id,
    latitude,
    longitude,
    id,
    house_building_no
  ) {
    return this.http.post(
      Constants.apiAddress + "/edit_customer_address",
      JSON.stringify({
        auth_token,
        place_label,
        address_line1,
        city,
        state,
        zip,
        country,
        apart_no,
        client_id,
        latitude,
        longitude,
        id,
        version_number,
        house_building_no,
      }),
      { headers: headers }
    );
  }
  deleteCustomerAddress(auth_token, client_id, address_id) {
    return this.http.post(
      Constants.apiAddress + "/remove_address_of_customer",
      JSON.stringify({ auth_token, client_id, address_id, version_number }),
      { headers: headers }
    );
  }

  addDeliveryPackageslisting(
    auth_token,
    no_of_deliveries,
    validity,
    validity_string,
    package_price,
    off_price
  ) {
    return this.http.post(
      Constants.apiAddress + "/add_delivery_plan_package",
      JSON.stringify({
        auth_token,
        no_of_deliveries,
        validity,
        validity_string,
        package_price,
        off_price,
        version_number,
      }),
      { headers: headers }
    );
  }
  editDeliveryPackageslisting(
    auth_token,
    no_of_deliveries,
    validity,
    validity_string,
    package_price,
    off_price,
    plan_id
  ) {
    return this.http.post(
      Constants.apiAddress + "/edit_delivery_plan_package",
      JSON.stringify({
        auth_token,
        no_of_deliveries,
        validity,
        validity_string,
        package_price,
        off_price,
        plan_id,
        version_number,
      }),
      { headers: headers }
    );
  }
  getDeliveryPackageslisting(auth_token, search_string, filter_type, limit) {
    return this.http.post(
      Constants.apiAddress + "/get_delivery_plan_package",
      JSON.stringify({
        auth_token,
        search_string,
        filter_type,
        limit,
        version_number,
      }),
      { headers: headers }
    );
  }
  getDeliveryPackageslistingByPage(
    auth_token,
    page,
    search_string,
    filter_type,
    limit
  ) {
    return this.http.post(
      Constants.apiAddress + "/get_delivery_plan_package",
      JSON.stringify({
        auth_token,
        page,
        search_string,
        filter_type,
        limit,
        version_number,
      }),
      { headers: headers }
    );
  }
  getDeliveryPackageslistingDetail(auth_token, plan_id) {
    return this.http.post(
      Constants.apiAddress + "/get_delivery_plan_detail",
      JSON.stringify({ auth_token, plan_id, version_number }),
      { headers: headers }
    );
  }
  deleteDeliveryPackageslisting(auth_token, plan_id) {
    return this.http.post(
      Constants.apiAddress + "/delete_delivery_plan_package",
      JSON.stringify({ auth_token, plan_id, version_number }),
      { headers: headers }
    );
  }

  getSubscriptionSubscriberlisting(
    auth_token,
    search_string,
    filter_type,
    status,
    limit
  ) {
    return this.http.post(
      Constants.apiAddress + "/get_customers_purchased_packages",
      JSON.stringify({
        auth_token,
        search_string,
        filter_type,
        status,
        limit,
        version_number,
      }),
      { headers: headers }
    );
  }
  getSubscriptionSubscriberlistingByPage(
    auth_token,
    page,
    search_string,
    filter_type,
    status,
    limit
  ) {
    return this.http.post(
      Constants.apiAddress + "/get_customers_purchased_packages",
      JSON.stringify({
        auth_token,
        page,
        search_string,
        filter_type,
        status,
        limit,
        version_number,
      }),
      { headers: headers }
    );
  }
  approveSubscription(auth_token, client_delivery_plan_id) {
    return this.http.post(
      Constants.apiAddress + "/approve_subscription",
      JSON.stringify({ auth_token, client_delivery_plan_id, version_number }),
      { headers: headers }
    );
  }
  reject_subscriptionPackages(auth_token, client_delivery_plan_id) {
    return this.http.post(
      Constants.apiAddress + "/reject_subscription",
      JSON.stringify({ auth_token, client_delivery_plan_id, version_number }),
      { headers: headers }
    );
  }
  orderDetailListing(
    auth_token,
    search_string,
    filter_type,
    city,
    page,
    limit
  ) {
    return this.http.post(
      Constants.apiAddress + "/order_text_detail_listing",
      JSON.stringify({
        auth_token,
        search_string,
        filter_type,
        city,
        page,
        limit,
        version_number,
      }),
      { headers: headers }
    );
  }
  order_text_detail_listing(
    auth_token,
    status,
    order_text_id,
    reject_message,
    order_id,
    phone_number,
    purchase_amount
  ) {
    return this.http.post(
      Constants.apiAddress + "/change_order_text_status",
      JSON.stringify({
        auth_token,
        status,
        order_text_id,
        reject_message,
        order_id,
        phone_number,
        version_number,
        purchase_amount,
      }),
      { headers: headers }
    );
  }
  getnotificationsettings(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/get_notification_setting_of_super_admin",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  updatenotification(auth_token, email, phone_number) {
    return this.http.post(
      Constants.apiAddress + "/update_notification_setting_of_super_admin",
      JSON.stringify({ auth_token, email, phone_number, version_number }),
      { headers: headers }
    );
  }
  sendContactsSupport(
    auth_token,
    status,
    order_text_id,
    contact_message,
    phone_number
  ) {
    return this.http.post(
      Constants.apiAddress + "/order_text_contact_message",
      JSON.stringify({
        auth_token,
        status,
        order_text_id,
        contact_message,
        phone_number,
        version_number,
      }),
      { headers: headers }
    );
  }
  getServiceArea(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/get_city_list",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  getDispencoryListing(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/logs_dispensary_listing",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  getorderlisting(
    client_id,
    auth_token,
    page,
    type,
    dispensary_id,
    search_string,
    start_date,
    end_date
  ) {
    return this.http.post(
      Constants.apiAddress + "/customer_order_listing",
      JSON.stringify({
        client_id,
        auth_token,
        page,
        type,
        dispensary_id,
        search_string,
        start_date,
        end_date,
        version_number,
      }),
      { headers: headers }
    );
  }
  getbusinessListAgainstCustomer(auth_token, client_id) {
    return this.http.post(
      Constants.apiAddress + "/order_dispensary_listing",
      JSON.stringify({ client_id, auth_token, version_number }),
      { headers: headers }
    );
  }
  getServiceAreaListWithBusiness(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/service_area_with_business_list",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  createEvient(
    auth_token,
    time,
    event_type,
    title,
    region,
    dispensary_id,
    phone_number_region,
    spending_amount,
    no_of_order,
    age,
    text,
    date,
    date_and_time,
    order_interpreter
  ) {
    return this.http.post(
      Constants.apiAddress + "/add_message_or_notification",
      JSON.stringify({
        auth_token,
        time,
        event_type,
        title,
        region,
        dispensary_id,
        phone_number_region,
        spending_amount,
        no_of_order,
        age,
        text,
        date,
        date_and_time,
        order_interpreter,
        version_number,
      }),
      { headers: headers }
    );
  }
  updateEvient(
    auth_token,
    time,
    event_type,
    title,
    region,
    dispensary_id,
    phone_number_region,
    spending_amount,
    no_of_order,
    age,
    text,
    date,
    date_and_time,
    event_id,
    order_interpreter
  ) {
    return this.http.post(
      Constants.apiAddress + "/edit_message_or_notification",
      JSON.stringify({
        auth_token,
        time,
        event_type,
        title,
        region,
        dispensary_id,
        phone_number_region,
        spending_amount,
        no_of_order,
        age,
        text,
        date,
        date_and_time,
        event_id,
        order_interpreter,
        version_number,
      }),
      { headers: headers }
    );
  }
  getCustomerEventList(
    auth_token,
    time,
    event_type,
    title,
    region,
    dispensary_id,
    phone_number_region,
    spending_amount,
    no_of_order,
    age,
    text,
    date,
    date_and_time,
    event_id,
    order_interpreter,
    limit,
    page
  ) {
    return this.http.post(
      Constants.apiAddress + "/customers_listing_message_or_notification",
      JSON.stringify({
        auth_token,
        time,
        event_type,
        title,
        region,
        dispensary_id,
        phone_number_region,
        spending_amount,
        no_of_order,
        age,
        text,
        date,
        date_and_time,
        event_id,
        order_interpreter,
        limit,
        page,
        version_number,
      }),
      { headers: headers }
    );
  }
  getEventslisting(auth_token, current_time_offset, limit) {
    return this.http.post(
      Constants.apiAddress + "/message_or_notification_listing",
      JSON.stringify({
        auth_token,
        current_time_offset,
        limit,
        version_number,
      }),
      { headers: headers }
    );
  }
  getEventslistingByPage(auth_token, current_time_offset, page, limit) {
    return this.http.post(
      Constants.apiAddress + "/message_or_notification_listing",
      JSON.stringify({
        auth_token,
        current_time_offset,
        page,
        limit,
        version_number,
      }),
      { headers: headers }
    );
  }
  deleteEvent(auth_token, event_id) {
    return this.http.post(
      Constants.apiAddress + "/cancel_message_or_notification",
      JSON.stringify({ auth_token, event_id, version_number }),
      { headers: headers }
    );
  }

  getFaqslisting(auth_token, limit) {
    return this.http.post(
      Constants.apiAddress + "/get_faqs_listing",
      JSON.stringify({ auth_token, limit, version_number }),
      { headers: headers }
    );
  }
  getFaqslistingByPage(auth_token, page, limit) {
    return this.http.post(
      Constants.apiAddress + "/get_faqs_listing",
      JSON.stringify({ auth_token, page, limit, version_number }),
      { headers: headers }
    );
  }
  addFaqs(auth_token, question, answer) {
    return this.http.post(
      Constants.apiAddress + "/add_faqs",
      JSON.stringify({ auth_token, question, answer, version_number }),
      { headers: headers }
    );
  }
  editFaqs(auth_token, question, answer, id_faqs) {
    return this.http.post(
      Constants.apiAddress + "/edit_faqs",
      JSON.stringify({ auth_token, question, answer, id_faqs, version_number }),
      { headers: headers }
    );
  }
  deleteFaqs(auth_token, id_faqs) {
    return this.http.post(
      Constants.apiAddress + "/delete_faqs",
      JSON.stringify({ auth_token, id_faqs, version_number }),
      { headers: headers }
    );
  }
  setFaqsSorting(auth_token, sorting_faqs) {
    return this.http.post(
      Constants.apiAddress + "/sorting_faqs",
      JSON.stringify({ auth_token, sorting_faqs, version_number }),
      { headers: headers }
    );
  }
  clearCachy(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/cache_clearing",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }

  getLogDetails(auth_token, type, status, dispensary_id, search_string) {
    return this.http.post(
      Constants.apiAddress + "/get_log_detail",
      JSON.stringify({
        auth_token,
        version_number,
        type,
        status,
        dispensary_id,
        search_string,
      }),
      { headers: headers }
    );
  }
  getdispensaryListing(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/dispensary_listing",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
//new functionality if wanted to only see the specific dispensary listings of specific category
  getSelectedDispensaryListing(auth_token, business_category_list) {
    return this.http.post(
      Constants.apiAddress + "/dispensary_listing",
      JSON.stringify({ auth_token, version_number, business_category_list }),
      { headers: headers }
    );
  }

  getdispensaryListingById(auth_token, city_id, search_string) {
    return this.http.post(
      Constants.apiAddress + "/dispensary_listing",
      JSON.stringify({ auth_token, city_id, search_string, version_number }),
      { headers: headers }
    );
  }
  getoutlets(auth_token, dispensary_id) {
    return this.http.post(
      Constants.apiAddress + "/get_outlets",
      JSON.stringify({ auth_token, version_number, dispensary_id }),
      { headers: headers }
    );
  }

  getordersListings(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/get_orders",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }

  getProblemListing(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/ticket_listing",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }

  // getordersListings(auth_token) {
  //   return this.http.post(Constants.apiAddress + '/get_orders', JSON.stringify({ auth_token, version_number}),
  //     { headers: headers });
  // }

  getservices(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/service_area_listing",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }

  profileData(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/get_dispensary_profile",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  getordersList(
    auth_token,
    status,
    limit,
    city_id,
    dispensary_id,
    outlet_id,
    index,
    selectionDayOpenTime,
    selectionDayCloseTime,
    page,
    order_type
  ) {
    return this.http.post(
      Constants.apiAddress + "/get_orders",
      JSON.stringify({
        auth_token,
        status,
        limit,
        city_id,
        dispensary_id,
        outlet_id,
        index,
        selectionDayOpenTime,
        selectionDayCloseTime,
        page,
        version_number,
        order_type,
      }),
      { headers: headers }
    );
  }

  searchOrdersList(
    auth_token,
    search_string,
    status,
    limit,
    city_id,
    dispensary_id,
    outlet_id,
    index,
    selectionDayOpenTime,
    selectionDayCloseTime,
    order_type
  ) {
    return this.http.post(
      Constants.apiAddress + "/get_orders",
      JSON.stringify({
        auth_token,
        search_string,
        status,
        limit,
        city_id,
        dispensary_id,
        outlet_id,
        index,
        selectionDayOpenTime,
        selectionDayCloseTime,
        version_number,
        order_type,
      }),
      { headers: headers }
    );
  }

  getOrderListByPage(
    auth_token,
    page,
    status,
    limit,
    city_id,
    dispensary_id,
    outlet_id,
    index,
    selectionDayOpenTime,
    selectionDayCloseTime,
    order_type
  ) {
    return this.http.post(
      Constants.apiAddress + "/get_orders",
      JSON.stringify({
        auth_token,
        page,
        status,
        limit,
        city_id,
        dispensary_id,
        outlet_id,
        index,
        selectionDayOpenTime,
        selectionDayCloseTime,
        version_number,
        order_type,
      }),
      { headers: headers }
    );
  }
  getOrderSearchListByPage(
    auth_token,
    search_string,
    page,
    status,
    limit,
    city_id,
    dispensary_id,
    outlet_id,
    index,
    selectionDayOpenTime,
    selectionDayCloseTime
  ) {
    return this.http.post(
      Constants.apiAddress + "/get_orders",
      JSON.stringify({
        auth_token,
        search_string,
        page,
        status,
        limit,
        city_id,
        dispensary_id,
        outlet_id,
        index,
        selectionDayOpenTime,
        selectionDayCloseTime,
        version_number,
      }),
      { headers: headers }
    );
  }
  getBatch(
    auth_token,
    outlet_id,
    index,
    selectionDayOpenTime,
    selectionDayCloseTime
  ) {
    return this.http.post(
      Constants.apiAddress + "/get_batches",
      JSON.stringify({
        auth_token,
        outlet_id,
        index,
        selectionDayOpenTime,
        selectionDayCloseTime,
        version_number,
      }),
      { headers: headers }
    );
  }
  searchBatch(
    auth_token,
    search_string,
    outlet_id,
    index,
    selectionDayOpenTime,
    selectionDayCloseTime
  ) {
    return this.http.post(
      Constants.apiAddress + "/get_batches",
      JSON.stringify({
        auth_token,
        search_string,
        outlet_id,
        index,
        selectionDayOpenTime,
        selectionDayCloseTime,
        version_number,
      }),
      { headers: headers }
    );
  }

  getBatchByPage(
    auth_token,
    page,
    outlet_id,
    index,
    selectionDayOpenTime,
    selectionDayCloseTime
  ) {
    return this.http.post(
      Constants.apiAddress + "/get_batches",
      JSON.stringify({
        auth_token,
        page,
        outlet_id,
        index,
        selectionDayOpenTime,
        selectionDayCloseTime,
        version_number,
      }),
      { headers: headers }
    );
  }

  orderStatus(auth_token, order_id, invoice_no) {
    return this.http.post(
      Constants.apiAddress + "/change_order_status",
      JSON.stringify({ auth_token, order_id, invoice_no, version_number }),
      { headers: headers }
    );
  }
  getbatchDetail(auth_token, batch_id) {
    return this.http.post(
      Constants.apiAddress + "/get_batch_detail",
      JSON.stringify({ auth_token, batch_id, version_number }),
      { headers: headers }
    );
  }
  searchDriverListInBatch(auth_token, search_string, order_search, batch_id) {
    return this.http.post(
      Constants.apiAddress + "/get_drivers",
      JSON.stringify({
        auth_token,
        search_string,
        order_search,
        batch_id,
        version_number,
      }),
      { headers: headers }
    );
  }

  bookOrder(auth_token, batch_id, driver_id) {
    return this.http.post(
      Constants.apiAddress + "/book_order",
      JSON.stringify({ auth_token, batch_id, driver_id, version_number }),
      { headers: headers }
    );
  }
  getDriverListInBatch(auth_token, batch_id) {
    return this.http.post(
      Constants.apiAddress + "/get_drivers",
      JSON.stringify({ auth_token, batch_id, version_number }),
      { headers: headers }
    );
  }
  removeBatch(auth_token, batch_id, order_list, type) {
    return this.http.post(
      Constants.apiAddress + "/edit_batch",
      JSON.stringify({
        auth_token,
        batch_id,
        order_list,
        type,
        version_number,
      }),
      { headers: headers }
    );
  }
  getQrCode(auth_token, order_id) {
    return this.http.post(
      Constants.apiAddress + "/generate_qr_code",
      JSON.stringify({ auth_token, order_id, version_number }),
      { headers: headers }
    );
  }
  manualDropOff(auth_token, order_id, driver_id, latitude, longitude) {
    return this.http.post(
      Constants.apiAddress + "/manual_drop_off",
      JSON.stringify({
        auth_token,
        order_id,
        driver_id,
        latitude,
        longitude,
        version_number,
      }),
      { headers: headers }
    );
  }
  trackOrder(auth_token, order_id) {
    return this.http.post(
      Constants.apiAddress + "/track_order",
      JSON.stringify({ auth_token, order_id, version_number }),
      { headers: headers }
    );
  }
  trackDriver(auth_token, driver_id, order_id) {
    return this.http.post(
      Constants.apiAddress + "/track_driver",
      JSON.stringify({ auth_token, driver_id, order_id, version_number }),
      { headers: headers }
    );
  }
  OrderBookNationWide(
    auth_token,
    order_no,
    third_party_name,
    third_party_url,
    tracking_id,
    deliver_date
  ) {
    return this.http.post(
      Constants.apiAddress + "/third_party_order_book",
      JSON.stringify({
        auth_token,
        order_no,
        third_party_name,
        third_party_url,
        tracking_id,
        deliver_date,
        version_number,
      }),
      { headers: headers }
    );
  }
  rebookOrder(auth_token, order_no) {
    return this.http.post(
      Constants.apiAddress + "/rebook_order",
      JSON.stringify({ auth_token, order_no, version_number }),
      { headers: headers }
    );
  }
  rebookProcess(auth_token, order_no) {
    return this.http.post(
      Constants.apiAddress + "/reprocess_order",
      JSON.stringify({ auth_token, order_no, version_number }),
      { headers: headers }
    );
  }
  cancelOrderStatus(auth_token, order_id) {
    return this.http.post(
      Constants.apiAddress + "/cancel_order",
      JSON.stringify({ auth_token, order_id, version_number }),
      { headers: headers }
    );
  }
  cancelBatchOrderStatus(auth_token, order_id) {
    return this.http.post(
      Constants.apiAddress + "/send_notification_for_cancel_order_to_driver",
      JSON.stringify({ auth_token, order_id, version_number }),
      { headers: headers }
    );
  }
  thirdPartycancelOrderStatus(auth_token, order_id) {
    return this.http.post(
      Constants.apiAddress + "/third_party_cancel_order",
      JSON.stringify({ auth_token, order_id, version_number }),
      { headers: headers }
    );
  }
  orderintransitthirdparty(auth_token, order_no) {
    return this.http.post(
      Constants.apiAddress + "/order_intransit_third_party",
      JSON.stringify({ auth_token, order_no, version_number }),
      { headers: headers }
    );
  }
  returnOrderStatus(auth_token, order_id) {
    return this.http.post(
      Constants.apiAddress + "/return_order",
      JSON.stringify({ auth_token, order_id, version_number }),
      { headers: headers }
    );
  }
  returnOrderStatusThairdParty(
    auth_token,
    order_id,
    deliver_person,
    deliver_handler,
    deliver_time,
    deliver_date
  ) {
    return this.http.post(
      Constants.apiAddress + "/third_party_return_order",
      JSON.stringify({
        auth_token,
        order_id,
        deliver_person,
        deliver_handler,
        deliver_time,
        deliver_date,
        version_number,
      }),
      { headers: headers }
    );
  }
  orderRollOver(auth_token, order_id) {
    return this.http.post(
      Constants.apiAddress + "/roll_over_order",
      JSON.stringify({ auth_token, order_id, version_number }),
      { headers: headers }
    );
  }
  DeliveryManType(auth_token, delivery_man_type, order_id) {
    return this.http.post(
      Constants.apiAddress + "/set_delivery_man_type",
      JSON.stringify({
        auth_token,
        delivery_man_type,
        order_id,
        version_number,
      }),
      { headers: headers }
    );
  }
  markDelivered(
    auth_token,
    order_no,
    deliver_person,
    deliver_handler,
    deliver_time,
    deliver_date
  ) {
    return this.http.post(
      Constants.apiAddress + "/order_mark_as_delivered_third_party",
      JSON.stringify({
        auth_token,
        order_no,
        deliver_person,
        deliver_handler,
        deliver_time,
        deliver_date,
        version_number,
      }),
      { headers: headers }
    );
  }

  dispensary_information(auth_token, dispensary_id) {
    return this.http.post(
      Constants.apiAddress + "/get_dispensary_information",
      JSON.stringify({ auth_token, dispensary_id, version_number }),
      { headers: headers }
    );
  }
  searchProducts(auth_token, search_string, dispensary_id) {
    return this.http.post(
      Constants.apiAddress + "/variant_listing",
      JSON.stringify({
        auth_token,
        search_string,
        dispensary_id,
        version_number,
      }),
      { headers: headers }
    );
  }
  searchCustomers(auth_token, search_string, dispensary_id) {
    return this.http.post(
      Constants.apiAddress + "/get_customers",
      JSON.stringify({
        auth_token,
        search_string,
        dispensary_id,
        version_number,
      }),
      { headers: headers }
    );
  }
  searchOutletsList(auth_token, search_string, dispensary_id) {
    return this.http.post(
      Constants.apiAddress + "/get_outlets",
      JSON.stringify({
        auth_token,
        search_string,
        dispensary_id,
        version_number,
      }),
      { headers: headers }
    );
  }
  setPrimaryCustomerAddress(auth_token, client_id, address_id) {
    return this.http.post(
      Constants.apiAddress + "/make_primary_address_of_customer",
      JSON.stringify({ auth_token, client_id, address_id, version_number }),
      { headers: headers }
    );
  }
  makePaymentMethodPrimaryCustomer(auth_token, payment_profile_id, client_id) {
    return this.http.post(
      Constants.apiAddress + "/make_payment_method_primary_of_customer",
      JSON.stringify({
        auth_token,
        version_number,
        payment_profile_id,
        client_id,
      }),
      { headers: headers }
    );
  }
  removePaymentMethodOfCustomer(auth_token, payment_profile_id, client_id) {
    return this.http.post(
      Constants.apiAddress + "/remove_payment_method_customer",
      JSON.stringify({
        auth_token,
        payment_profile_id,
        client_id,
        version_number,
      }),
      { headers: headers }
    );
  }
  addPaymentMethodCustomer(
    auth_token,
    card_number,
    holder_name,
    expiry_date,
    card_cvv,
    client_id,
    card_type
  ) {
    return this.http.post(
      Constants.apiAddress + "/customer_add_payment_method",
      JSON.stringify({
        auth_token,
        card_number,
        holder_name,
        expiry_date,
        card_cvv,
        client_id,
        card_type,
        version_number,
      }),
      { headers: headers }
    );
  }
  createOrder(
    auth_token,
    products,
    notes,
    total_price,
    quantity,
    discount,
    tax_charges,
    delivery_charges,
    delivery_charges_actual,
    customer_id,
    customer_name,
    customer_email,
    customer_phone_number,
    subscription,
    outlet_id,
    outlet_address,
    delivery_address,
    sub_total,
    delivery_man_type,
    payment_gateway,
    logistics_order,
    current_day,
    business_type,
    open_time,
    close_time,
    day_index,
    third_party_string,
    current_time,
    dispensary_id,
    platform_fee_waive_off
  ) {
    return this.http.post(
      Constants.apiAddress + "/create_order",
      JSON.stringify({
        auth_token,
        products,
        notes,
        total_price,
        quantity,
        discount,
        tax_charges,
        delivery_charges,
        delivery_charges_actual,
        customer_id,
        customer_name,
        customer_email,
        customer_phone_number,
        subscription,
        outlet_id,
        outlet_address,
        delivery_address,
        sub_total,
        delivery_man_type,
        payment_gateway,
        logistics_order,
        current_day,
        business_type,
        open_time,
        close_time,
        day_index,
        third_party_string,
        current_time,
        dispensary_id,
        platform_fee_waive_off,
        version_number,
      }),
      { headers: headers }
    );
  }
  showCustomerList(auth_token, phone_number) {
    return this.http.post(
      Constants.apiAddress + "/get_customer_detail",
      JSON.stringify({ auth_token, phone_number, version_number }),
      { headers: headers }
    );
  }
  editCustomerAddresss(
    auth_token,
    address_line1,
    street,
    city,
    state,
    zip,
    country,
    apart_no,
    client_id,
    latitude,
    longitude,
    place_label,
    id,
    house_building_no
  ) {
    return this.http.post(
      Constants.apiAddress + "/edit_customer_address",
      JSON.stringify({
        auth_token,
        address_line1,
        street,
        city,
        state,
        zip,
        country,
        apart_no,
        client_id,
        latitude,
        longitude,
        place_label,
        id,
        version_number,
        house_building_no,
      }),
      { headers: headers }
    );
  }
  businessProfile(auth_token, dispensary_id) {
    return this.http.post(
      Constants.apiAddress + "/business_profile",
      JSON.stringify({ auth_token, dispensary_id, version_number }),
      { headers: headers }
    );
  }
  getSlotsListWithAddress(
    auth_token,
    current_day,
    delivery_address,
    products,
    current_time,
    customer_id,
    sub_total,
    dispensary_id
  ) {
    return this.http.post(
      Constants.apiAddress + "/get_slot_timing_according_to_address",
      JSON.stringify({
        auth_token,
        current_day,
        delivery_address,
        products,
        current_time,
        customer_id,
        sub_total,
        dispensary_id,
        version_number,
      }),
      { headers: headers }
    );
  }
  getPlatformChargesForFee(auth_token, dispensary_id) {
    return this.http.post(
      Constants.apiAddress + "/get_delivery_charges",
      JSON.stringify({ auth_token, dispensary_id, version_number }),
      { headers: headers }
    );
  }
  updateOrder(
    auth_token,
    products,
    notes,
    total_price,
    quantity,
    discount,
    tax_charges,
    delivery_charges,
    delivery_charges_actual,
    customer_id,
    customer_name,
    customer_email,
    customer_phone_number,
    outlet_id,
    outlet_address,
    delivery_address,
    sub_total,
    delivery_man_type,
    payment_gateway,
    current_day,
    business_type,
    open_time,
    close_time,
    day_index,
    third_party_string,
    order_id,
    off_price_subscribed_checked,
    current_time,
    dispensary_id,
    platform_fee_waive_off
  ) {
    return this.http.post(
      Constants.apiAddress + "/edit_order",
      JSON.stringify({
        auth_token,
        products,
        notes,
        total_price,
        quantity,
        discount,
        tax_charges,
        delivery_charges,
        delivery_charges_actual,
        customer_id,
        customer_name,
        customer_email,
        customer_phone_number,
        outlet_id,
        outlet_address,
        delivery_address,
        sub_total,
        delivery_man_type,
        payment_gateway,
        current_day,
        business_type,
        open_time,
        close_time,
        day_index,
        third_party_string,
        order_id,
        off_price_subscribed_checked,
        current_time,
        dispensary_id,
        platform_fee_waive_off,
        version_number,
      }),
      { headers: headers }
    );
  }
  freeDeliveryFeeCharges(data: any) {
    data["version_number"] = version_number;
    return this.http.post(
      Constants.apiAddress + "/update_delivery_charges",
      JSON.stringify(data),
      { headers: headers }
    );
  }
  updateDeliveryCharges(data: any) {
    data["version_number"] = version_number;
    return this.http.post(
      Constants.apiAddress + "/update_delivery_charges",
      JSON.stringify(data),
      { headers: headers }
    );
  }
  getVariantDetail(auth_token, variant_id) {
    return this.http.post(
      Constants.apiAddress + "/get_variant_detail",
      JSON.stringify({ auth_token, variant_id, version_number }),
      { headers: headers }
    );
  }
  updatePrice(auth_token, variant_id, price, variant_name) {
    return this.http.post(
      Constants.apiAddress + "/update_variant_price",
      JSON.stringify({
        auth_token,
        variant_id,
        price,
        variant_name,
        version_number,
      }),
      { headers: headers }
    );
  }
  getStatementByPage(auth_token, page, business_id) {
    return this.http.post(
      Constants.apiAddress + "/get_account_statement",
      JSON.stringify({ auth_token, page, business_id, version_number }),
      { headers: headers }
    );
  }

  getRolesList(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/get_role_list",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }

  addNewRoles(auth_token, name, email, roles, password) {
    let is_prod = this.is_prod;
    return this.http.post(
      Constants.apiAddress + "/invite_superuser",
      JSON.stringify({
        auth_token,
        name,
        email,
        roles,
        password,
        is_prod,
        version_number,
      }),
      { headers: headers }
    );
  }

  getRolesData(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/get_invited_superuser",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }

  getEditAdminUser(auth_token, user_id) {
    return this.http.post(
      Constants.apiAddress + "/get_superuser_roles_details",
      JSON.stringify({ auth_token, user_id, version_number }),
      { headers: headers }
    );
  }

  updateUserRole(auth_token, user_id, roles) {
    return this.http.post(
      Constants.apiAddress + "/update_superuser_roles",
      JSON.stringify({ auth_token, user_id, roles, version_number }),
      { headers: headers }
    );
  }

  getAssignedRoles(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/get_superuser_assigned_roles",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }

  editBusinessCategoryImages(
    auth_token,
    business_prod_image_relation,
    dispensary_id
  ) {
    return this.http.post(
      Constants.apiAddress + "/edit_business_cat_disp_image",
      JSON.stringify({
        auth_token,
        business_prod_image_relation,
        dispensary_id,
        version_number,
      }),
      { headers: headers }
    );
  }

  getBusinessCategoryImages(auth_token, dispensary_id) {
    return this.http.post(
      Constants.apiAddress + "/get_business_cat_disp_images",
      JSON.stringify({ auth_token, dispensary_id, version_number }),
      { headers: headers }
    );
  }

  addRegisteredVendor(data) {
    data["version_number"] = version_number;
    return this.http.post(Constants.apiAddress + "/invite_vendor", data, {
      headers: headers,
    });
  }

  getRegisteredVendor(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/get_business_vendors",
      JSON.stringify({ auth_token, version_number }),
      { headers: headers }
    );
  }
  getOrderHistory(
    auth_token,
    category_id,
    city_id,
    page,
    limit,
    filter_type,
    business_id,
    start_date,
    end_date,
    total_platform_fee,
    total_deliverey_charges
  ) {
    return this.http.post(
      Constants.apiAddress + "/business_order_sales_report",
      JSON.stringify({
        auth_token,
        category_id,
        city_id,
        page,
        limit,
        filter_type,
        business_id,
        start_date,
        end_date,
        version_number,
        total_platform_fee,
        total_deliverey_charges,
      }),
      { headers: headers }
    );
  }

  orderRequest(data) {
    data["version_number"] = version_number;
    return this.http.post(
      Constants.apiAddress + "/add_order_text_from_admin",
      JSON.stringify(data),
      { headers: headers }
    );
  }
  orderRequestImage(data) {
    data["version_number"] = version_number;
    const body = new FormData();
    body.append("version_number", data["version_number"]);
    body.append("auth_token", data["auth_token"]);
    // body.append('order_text', data['order_text']);
    body.append("image", data["images_list"]);
    // body.append('address', data['order_text']);
    // body.append('city', data['city']);
    // body.append('user_id', data['user_id']);
    // body.append('social_platform', data['social_platform']);
    // body.append('dispensary_id', data['dispensary_id']);

    return this.http.post(
      Constants.apiAddress + "/upload_order_text_image",
      body,
      { headers: headers }
    );
  }
  getDriverOrderHistory(data) {
    data.version_number = version_number;
    return this.http.post(
      Constants.apiAddress + "/driver_order_detail",
      JSON.stringify(data),
      { headers: headers }
    );
  }
  changeOrderStatus(data) {
    data.version_number = version_number;
    return this.http.post(
      Constants.apiAddress + "/update_status_for_pickup_and_dine",
      JSON.stringify(data),
      { headers: headers }
    );
  }
  createPickUpOrder(
    auth_token,
    products,
    notes,
    total_price,
    quantity,
    discount,
    tax_charges,
    delivery_charges_actual,
    customer_id,
    customer_name,
    customer_email,
    customer_phone_number,
    outlet_id,
    outlet_address,
    sub_total,
    delivery_man_type,
    payment_gateway,
    current_day,
    business_type,
    open_time,
    close_time,
    day_index,
    third_party_string,
    current_time,
    dispensary_id,
    platform_fee_waive_off
  ) {
    return this.http.post(
      Constants.apiAddress + "/create_pickup_order",
      JSON.stringify({
        auth_token,
        products,
        notes,
        total_price,
        quantity,
        discount,
        tax_charges,
        delivery_charges_actual,
        customer_id,
        customer_name,
        customer_email,
        customer_phone_number,
        outlet_id,
        outlet_address,
        sub_total,
        delivery_man_type,
        payment_gateway,
        current_day,
        business_type,
        open_time,
        close_time,
        day_index,
        third_party_string,
        current_time,
        dispensary_id,
        platform_fee_waive_off,
        version_number,
      }),
      { headers: headers }
    );
  }
  updatePickUpOrder(
    auth_token,
    products,
    notes,
    total_price,
    quantity,
    discount,
    tax_charges,
    delivery_charges_actual,
    customer_id,
    customer_name,
    customer_email,
    customer_phone_number,
    outlet_id,
    outlet_address,
    sub_total,
    delivery_man_type,
    payment_gateway,
    current_day,
    business_type,
    open_time,
    close_time,
    day_index,
    third_party_string,
    current_time,
    dispensary_id,
    platform_fee_waive_off
  ) {
    return this.http.post(
      Constants.apiAddress + "/pickup_order_update",
      JSON.stringify({
        auth_token,
        products,
        notes,
        total_price,
        quantity,
        discount,
        tax_charges,
        delivery_charges_actual,
        customer_id,
        customer_name,
        customer_email,
        customer_phone_number,
        outlet_id,
        outlet_address,
        sub_total,
        delivery_man_type,
        payment_gateway,
        current_day,
        business_type,
        open_time,
        close_time,
        day_index,
        third_party_string,
        current_time,
        dispensary_id,
        platform_fee_waive_off,
        version_number,
      }),
      { headers: headers }
    );
  }
  getPaymentMethodlist(auth_token, client_id) {
    return this.http.post(
      Constants.apiAddress + "/customer_get_payment_method",
      JSON.stringify({ auth_token, client_id, version_number }),
      { headers: headers }
    );
  }
  getBusinessRating(
    auth_token,
    search_string,
    dispensary_id,
    city,
    limit,
    page,
    Rating_no
  ) {
    return this.http.post(
      Constants.apiAddress + "/get_rating_all",
      JSON.stringify({
        auth_token,
        version_number,
        search_string,
        dispensary_id,
        city,
        limit,
        page,
        Rating_no,
      }),
      { headers: headers }
    );
  }
  getBusinessRatingByPage(
    auth_token,
    search_string,
    dispensary_id,
    city,
    page,
    limit
  ) {
    return this.http.post(
      Constants.apiAddress + "/get_rating_all",
      JSON.stringify({
        auth_token,
        version_number,
        search_string,
        dispensary_id,
        city,
        page,
        limit,
      }),
      { headers: headers }
    );
  }
  getchain(auth_token, chain_name, items) {
    return this.http.post(
      Constants.apiAddress + "/create_chain_with_dispensaries",
      JSON.stringify({ auth_token, chain_name, items }),
      { headers: headers }
    );
  }
  showchain(auth_token) {
    return this.http.post(
      Constants.apiAddress + "/show_chains",
      JSON.stringify({ auth_token }),
      { headers: headers }
    );
  }
  get_dispensaries_chain(auth_token, chain_id) {
    return this.http.post(
      Constants.apiAddress + "/get_dispensaries_with_chain",
      JSON.stringify({ auth_token, chain_id }),
      { headers: headers }
    );
  }
  get_edit_chain(auth_token, chain_id, chain_name, items) {
    return this.http.post(
      Constants.apiAddress + "/edit_dispensaries_with_chain",
      JSON.stringify({ auth_token, chain_id, chain_name, items }),
      { headers: headers }
    );
  }
  delete_chain(auth_token, chain_id) {
    return this.http.post(
      Constants.apiAddress + "/remove_chain",
      JSON.stringify({ auth_token, chain_id }),
      { headers: headers }
    );
  }
  Show_dropoff(auth_token, status, city, page, search) {
    return this.http.post(
      Constants.apiAddress + "/force_dropoff_address_list",
      JSON.stringify({ auth_token, status, city, page, search, version_number }),
      { headers: headers }
    );
  }

  //commented out extra api calls because of single functionality
  
  // Show_dropoffbyPage(auth_token, page) {
  //   return this.http.post(
  //     Constants.apiAddress + "/force_dropoff_address_list",
  //     JSON.stringify({ auth_token, version_number, page }),
  //     { headers: headers }
  //   );
  // }
  Show_aprovedby(auth_token, id, action_type) {
    return this.http.post(
      Constants.apiAddress + "/force_dropoff_address_approve_or_reject",
      JSON.stringify({ auth_token, version_number, id, action_type }),
      { headers: headers }
    );
  }
  // Show_SearchForcedoff(auth_token, search, page) {
  //   return this.http.post(
  //     Constants.apiAddress + "/force_dropoff_address_list",
  //     JSON.stringify({ auth_token, version_number, search, page }),
  //     { headers: headers }
  //   );
  // }

  get_Cities(auth_token){
   

    // return of({ status: true, "city_list": [
    //     {
    //         "city": "Glasgow City",
    //         "id": 133
    //     },
    //     {
    //         "city": "Renfrewshire",
    //         "id": 529
    //     }
    // ] });
    //commenting out and hardcoded results

    return this.http.post(
      Constants.apiAddress + "/get_business_city_list",
      JSON.stringify({auth_token, version_number}), 
      {headers : headers}

    )
  }

  // Show_filterResult(auth_token, status, page) {
  //   return this.http.post(
  //     Constants.apiAddress + "/force_dropoff_address_list",
  //     JSON.stringify({ auth_token, version_number, status, page }),
  //     { headers: headers }
  //   );
  // }
  // Show_servicefilterResult(auth_token, status, city, page, search = '') {
  //   return this.http.post(
  //     Constants.apiAddress + "/force_dropoff_address_list",
  //     JSON.stringify({ auth_token, status, city, page, search, version_number }),
  //     { headers: headers }
  //   );
  // }
  getSubscriptions(
    auth_token,
    page,
    limit,
    subscription_status_filter,
    subscription_type_filter,
    search,
    business_id
  ) {
    return this.http.post(
      Constants.apiAddress + "/order_subscription_list",
      JSON.stringify({
        auth_token,
        page,
        limit,
        subscription_status_filter,
        subscription_type_filter,
        search,
        business_id,
        version_number,
      }),
      { headers: headers }
    );
  }
  changeSubscriptionStatus(auth_token, id, subscription_status) {
    return this.http.post(
      Constants.apiAddress + "/change_subscription_status",
      JSON.stringify({ auth_token, id, subscription_status, version_number }),
      { headers: headers }
    );
  }

  importProducs(auth_token, business_id, import_type, lookup_by, product_list) {
    return this.http.post(
      Constants.apiAddress + "/import_business_products",
      JSON.stringify({
        auth_token,
        business_id,
        import_type,
        lookup_by,
        product_list,
        version_number,
      }),
      { headers: headers }
    );
  }

  exportProducs(auth_token, business_id, category_list) {
    return this.http.post(
      Constants.apiAddress + "/export_business_products",
      JSON.stringify({
        auth_token,
        business_id,
        category_list,
        version_number,
      }),
      { headers: headers }
    );
  }

  // added by zeeshan for chat
  getMessageListing(params) {
    params["version_number"] = version_number;
    return this.http.post(
      Constants.apiAddress + "/message_listing",
      JSON.stringify(params),
      { headers: headers }
    );
  }

  getProblemDetail(auth_token,issue_id) {

    issue_id = parseInt(issue_id)
    debugger
    return this.http.post(  Constants.apiAddress + "/ticket_detail", JSON.stringify({auth_token ,issue_id, version_number}),{ headers: headers }
    );
  }


  sendMessage(params) {
    params["version_number"] = version_number;
    return this.http.post(
      Constants.apiAddress + "/send_message_admin",
      JSON.stringify(params),
      { headers: headers }
    );
  }

  sendMessageImage(params) {
    params["version_number"] = version_number;
    const body = new FormData();
    body.append("version_number", params["version_number"]);
    body.append("auth_token", params["auth_token"]);
    body.append("image", params["image"]);
    return this.http.post(
      Constants.apiAddress + "/upload_message_image",
      body,
      { headers: headers }
    );
  }

  messageStatusChangeToRead(params) {
    params["version_number"] = version_number;
    return this.http.post(
      Constants.apiAddress + "/read_message_admin",
      JSON.stringify(params),
      { headers: headers }
    );
  }

  getUnreadMessagesCount(params) {
    return this.http.post(
      Constants.apiAddress + "/order_unread_counts",
      JSON.stringify(params),
      { headers: headers }
    );
  }

  updateLocalDeliveryCharges(param) {
    param["version_number"] = version_number;
    return this.http.post(
      Constants.apiAddress + "/update_local_delivery_charges",
      JSON.stringify(param),
      { headers: headers }
    );
  }

  getCityDeliveryCharges(param) {
    param["version_number"] = version_number;
    return this.http.post(
      Constants.apiAddress + "/get_city_delivery_charges",
      JSON.stringify(param),
      { headers: headers }
    );
  }

  getBusinessOrderHistory(
    auth_token,
    page,
    limit,
    start_date,
    end_date,
    outlet_id
  ) {
    return this.http.post(
      Constants.apiAddress + "/outlet_order_detail_report",
      JSON.stringify({
        auth_token,
        page,
        limit,
        start_date,
        end_date,
        version_number,
        outlet_id,
      }),
      { headers: headers }
    );
  }

  financialBoardData(
    auth_token,
    type,
    min_date,
    max_date,
    business_list,
    business_category_list
  ) {
    return this.http.post(
      Constants.apiAddress + "/financial_dashboard_report",
      JSON.stringify({
        auth_token,
        type,
        min_date,
        max_date,
        business_list,
        business_category_list,
        version_number,
      }),
      { headers: headers }
    );
  }

  resolvedProblem(
    auth_token,
    issue_id,
    internal_comments,
    external_comments,
    favor,
    against
  ) {
    return this.http.post(
      Constants.apiAddress + "/resolve_ticket",
      JSON.stringify({
        auth_token,
        issue_id,
        internal_comments,
        external_comments,
        favor,
        against,
        version_number,
      }),
      { headers: headers }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/data.service.ts